import React from 'react';
import { Mission, PAYMENT_ON_HIRE, PAYMENT_ON_START, PAYMENT_ON_FINISH } from '../../types';

interface PaymentTrackerProps {
  mission: Mission;
  label?: { hire: string; start: string; finish: string; title: string; paid: string; remaining: string };
}

export const PaymentTracker: React.FC<PaymentTrackerProps> = ({ mission, label }) => {
  const { reward, payments } = mission;
  const totalPaid = payments.hired + payments.started + payments.finished;
  const remaining = reward - totalPaid;

  const steps = [
    { key: 'hired',    pct: PAYMENT_ON_HIRE * 100,   amount: reward * PAYMENT_ON_HIRE,   sent: payments.hired > 0,   label: label?.hire ?? 'On Hire' },
    { key: 'started',  pct: PAYMENT_ON_START * 100,  amount: reward * PAYMENT_ON_START,  sent: payments.started > 0, label: label?.start ?? 'On Start' },
    { key: 'finished', pct: PAYMENT_ON_FINISH * 100, amount: reward * PAYMENT_ON_FINISH, sent: payments.finished > 0, label: label?.finish ?? 'On Finish' },
  ];

  return (
    <div className="payment-tracker">
      <h4 className="payment-tracker-title">💰 {label?.title ?? 'Payment Progress'}</h4>
      <div className="payment-steps">
        {steps.map((s) => (
          <div key={s.key} className={`payment-step ${s.sent ? 'step-sent' : 'step-pending'}`}>
            <span className="step-pct">{s.pct}%</span>
            <span className="step-label">{s.label}</span>
            <span className="step-amount">€{s.amount.toFixed(2)}</span>
            <span className="step-status">{s.sent ? '✓ Sent' : '⏳ Pending'}</span>
          </div>
        ))}
      </div>
      <div className="payment-summary">
        <span>{label?.paid ?? 'Paid'}: <strong>€{totalPaid.toFixed(2)}</strong></span>
        <span>{label?.remaining ?? 'Remaining'}: <strong>€{remaining.toFixed(2)}</strong></span>
      </div>
      <div className="payment-bar-track">
        <div className="payment-bar-fill" style={{ width: `${(totalPaid / reward) * 100}%` }} />
      </div>
    </div>
  );
};
